import "../styles/contactus.css";
import logo from "../assets/dcbiomedical-logo.png";
import fbLogo from "../assets/facebook-logo.svg";
import LnLogo from "../assets/linkedin-logo.svg";
import { useState } from "react";
import { usePublicInfo } from "../hooks/use-public-info";

function ContactUs() {
  const {info, loading } = usePublicInfo();

  // form state
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // confirmation message
  const [status, setStatus] = useState("")

  const stripPhone = (p) => p.replace(/[^\d+]/g, "");
  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending");
    const API_BASE = "https://dcbiomedical-api-357987547858.us-central1.run.app";

    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ email, subject, message}),
      });
      
      const data = await res.json();

      if (res.ok){
        setStatus("Your message has been sent!");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        setStatus("Error: " + data.error +" Please directly email service@dcbiomedical.com.");
      }
    }catch (err) {
      console.error(err);
      setStatus("An unexpected error occurred.");
    }
    };

  if (loading) return <p>Loading...</p>;
  if (!info) return <p>Contact information unavailable.</p>;    
  return (
    <div className="contact-us">
      <div className="contact-us-header">
        <h1>Get in Touch</h1>
        <p>We’d love to hear from you. Fill out the form or reach us directly.</p>
      </div>

     <div className="contact-container">
  {/* Left column = Contact info + Social */}
  <div className="contact-left">
    <div className="contact-info">
      <img src={logo} alt="DC Biomedical Logo" className="contact-logo" />
      <div className="contact-details">
      <p className="contact-address">
                    <a
                        href="https://www.google.com/maps/search/?api=1&query=33+Sangra+Court+Unit+1+Streamwood+IL+60107"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        33 Sangra Court Unit 1 <br />
                        Streamwood, IL 60107
                    </a>
                    </p>
        <p><strong>Phone: </strong><a href={`tel:${stripPhone(info.phone)}`}>(847) 338-4950</a></p>
        <p><strong>Toll-Free: </strong><a href={`tel:${stripPhone(info.toll)}`}>(877) 727-4715</a></p>
        <p><strong>Fax: </strong><a href={`tel:${stripPhone(info.fax)}`}>(630) 289-8815</a></p>
        <p><strong>Email: </strong><a href={`mailto:${info.email}`}>{info.email}</a></p>
      </div>
    </div>

    <div className="contact-social">
      <h3>Follow Us</h3>
      <div className="social-links">
        <a href={info.socials.facebook}target="_blank" rel="noopener noreferrer">
          <img src={fbLogo} alt="Facebook" />
        </a>
        <a href={info.socials.linkedin} target="_blank" rel="noopener noreferrer">
          <img src={LnLogo} alt="LinkedIn" />
        </a>
      </div>
    </div>
  </div>

  {/* Right column = Form */}
  <form className="contact-form" onSubmit={handleSubmit}>
    
  {/* Status message (success or error) */}
  {status && (
    <div className={`status-banner ${
    status === "Sending"
      ? "" 
      : status.includes("Error")
      ? "error"
      : "success"}`}>
      {status}
    </div>
  )}
    <label htmlFor="email">Your Email</label>
    <input
            type="email"
            id="email"
            placeholder="Enter your email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

    <label htmlFor="subject">Subject</label>
    <input
            type="text"
            id="subject"
            placeholder="Enter subject"
            required
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />

    <label htmlFor="message">Message</label>
    <textarea
            id="message"
            rows="6"
            placeholder="Type your message here..."
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>

<button type="submit" disabled={status === "Sending"}>
  {status === "Sending" ? "Sending..." : "Send Message"}
</button>
  </form>
</div>
    </div>
  );
}

export default ContactUs;
